import React, { Fragment } from 'react'
import { Typography, Button, Box } from '@mui/material'
import { usePutAway } from '../../Context/usePutAway'
import { putAwayActions } from '../../actions/putAwayActions'

interface StepBackNotificationProps {}

export const StepBackNotification: React.FC<StepBackNotificationProps> = () => {
  const { dispatch } = usePutAway()
  const { setIsShowNotification, handleResetPage } = putAwayActions()

  return (
    <Fragment>
      <Box
        component='div'
        display='flex'
        flexDirection='column'
        flexWrap='nowrap'
        alignItems='center'
        padding='10px 20px 0 20px'
        border='1px solid red'
        color='red'
        width='83%'
        borderRadius='10px'
        marginTop='5%'
      >
        <Typography
          variant='h6'
          component='p'
          style={{ textAlign: 'center', textAlignLast: 'center' }}
        >
          Al volver la información ingresada se eliminará. ¿Está seguro/a que
          desea eliminarla?
        </Typography>

        <Button
          type='submit'
          fullWidth
          variant='outlined'
          color='primary'
          style={{
            marginTop: '20px',
            width: '95%',
            minWidth: '95%'
          }}
          onClick={() => {
            handleResetPage()
            dispatch(setIsShowNotification(false))
          }}
        >
          Sí, deseo eliminarla
        </Button>

        <Button
          type='submit'
          fullWidth
          variant='outlined'
          color='primary'
          style={{
            marginTop: '20px',
            width: '95%',
            minWidth: '95%',
            marginBottom: '20px'
          }}
          onClick={() => dispatch(setIsShowNotification(false))}
        >
          No, deseo permanecer aquí
        </Button>
      </Box>
    </Fragment>
  )
}
